/**
 * Portal (panel) URLs. Override with NEXT_PUBLIC_PORTAL_BASE_URL when the panel host differs.
 */
const rawBase = String(
  typeof process !== 'undefined' && process.env.NEXT_PUBLIC_PORTAL_BASE_URL
    ? process.env.NEXT_PUBLIC_PORTAL_BASE_URL
    : 'https://portal.airestro360.com',
).replace(/\/+$/, '')

export const PORTAL_BASE_URL = rawBase
export const PORTAL_LOGIN_URL = `${PORTAL_BASE_URL}/login`
export const PORTAL_DASHBOARD_URL = `${PORTAL_BASE_URL}/dashboard`

/** AI Restro 360 app — header Log in / Get started. */
const APP_AIRESTRO_BASE = 'https://app.airestro360.com'.replace(/\/+$/, '')
export const RESTRO_LOGIN_URL = `${APP_AIRESTRO_BASE}/login`
/** Same as marketing “Get started” (app root). */
export const RESTRO_REGISTER_URL = `${APP_AIRESTRO_BASE}/`
